<template>
  <div class="CertResult">
    <van-nav-bar title="证书查询系统" left-arrow @click-left="onClickLeft" />
    <div style="min-height: 500px">
      <van-collapse v-model="activeNames" accordion>
        <van-collapse-item v-for="(item, index) in certData" :key="index" :title="item.certName+'-'+item.certNumber" :name="index">
          <section>
            <h2>基础信息</h2>
            <van-cell-group>
              <van-cell class="inputBox" title="姓名" :value="item.certName" />
              <van-cell class="inputBox" title="证书编号" :value="item.certNumber" />
              <van-cell class="inputBox" title="发证时间" :value="item.certIssuedDate" />
            </van-cell-group>
            <h2>证书图片</h2>
            <div class="image">
              <van-image :src="item.bigPic" class="pic" @click="bigPic(index)" />
            </div>
          </section>
        </van-collapse-item>
      </van-collapse>
      <div class="noData" v-if="certData.length == 0">没有查询到数据</div>
    </div>
    <div class="footer">
      <p>北京阿叟阿巴科技有限公司</p>
      <p>ALSOLIFE 2017 All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
import {Toast, Cell, CellGroup, Button, NavBar, Image, ImagePreview, Collapse, CollapseItem } from 'vant'
import { getCertInfo } from '../../api/certAndScore'

export default {
  name: 'CertResult',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  data() {
    return {
      activeNames: -1,
      certData: []
    }
  },
  created() {
    localStorage.removeItem('CertQuery')
    // console.log(JSON.parse(this.$route.query.data))
    let data = JSON.parse(this.$route.query.data)
    console.log(data)
    this.getCertInfo(data)
  },
  mounted() {
    if (localStorage.getItem('CertResulttNum') >= 0) {
      localStorage['CertResulttNum'] = JSON.parse(localStorage.getItem('CertResulttNum')) + 1
    } else {
      localStorage['CertResulttNum'] = JSON.parse(localStorage.getItem('CertResulttNum'))
    }
  },
  methods: {
    getCertInfo(query) {
      let that = this
      this.loading = true
      getCertInfo(query)
        .then(function(res) {
          that.loading = false
          if (res.status == 200) {
            console.log(res)
            that.certData = res.business
            that.certData.forEach((item, index) => {
              that.certData[index].bigPic = item.certImgSrc.replace(/jpg/g, "png") + '?' + new Date().getTime()
            })
          } else {
            Toast.fail(res.statusText)
          }
        })
        .catch(function(error) {
          that.loading = false
          Toast('网络出现错误\n请稍后重试' || error)
        })
    },
    onClickLeft() { // 返回上一层
      this.$router.go(JSON.parse(localStorage.getItem('CertResulttNum')) ? -JSON.parse(localStorage.getItem('CertResulttNum')) : -1)
    },
    bigPic(index) { // 图片放大查看
      ImagePreview([
        this.certData[index].bigPic
      ])
    }
  }
}
</script>

<style lang="less">
.CertResult {
  h2 {
    font-size: 14px;
    font-weight: 400;
    padding: 15px;
    color: rgba(69, 90, 100, .6);
    margin: 0;
  }
  section {
    background: #f7f7f7;
    padding: 10px;
    margin-bottom: 10vw;
  }
  .inputBox{
    div:first-child{
      flex: 1;
    }
    div:last-child{
      flex: 3;
    }
  }
  .image {
    background: #fff;
    padding: 10px;
    .pic {
      display: block;
      width: 100%;
      margin: 0 auto;
    }
  }
  .noData {
    font-size: 14px;
    text-align: center;
    padding: 20px;
    color: #b9b9b9;
  }
  .footer{
    p {
      font-size: 12px;
      text-align: center;
      color: rgba(0, 0, 0, .4);
    }
  }
}
</style>
